export enum DocumentReferenceType {
  Payment = 'Payment',
  Order = 'Order',
  FinancialProduct = 'FinancialProduct',
  EducationProvider = 'EducationProvider',
  Company = 'Company',
  User = 'User',
}

export interface IDocumentReference<T = string> {
  document: T
  documentType: DocumentReferenceType
}
